export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'The muscle healing process looks confusing. This method organizes everything: first the inflammatory phase, then the repair phase, then remodeling and return-to-play.',
  },
  {
    emoji: '🔤',
    title: 'You get stuck with exercise selection',
    desc: 'You learn the guided way, recognizing which exercises help fiber alignment and which ones are too risky. No more guessing.',
  },
  {
    emoji: '🧩',
    title: "You can't build a complete protocol",
    desc: 'You learn the complete 360° structure to build routines that actually heal the tissue instead of just masking the pain.',
  },
  {
    emoji: '🎯',
    title: 'You fear re-injury',
    desc: 'Guessing with muscle tears is dangerous. A clear progression framework is what keeps your fibers safe until they can handle explosive loads again.',
  },
];
